export default "/images/25d7a6ba265e326d7878a0eccf188a81.avif";